import { render } from "./OrthopedicsView.vue?vue&type=template&id=673bbf73&scoped=true"
import script from "./OrthopedicsView.vue?vue&type=script&lang=js"
export * from "./OrthopedicsView.vue?vue&type=script&lang=js"

import "./OrthopedicsView.vue?vue&type=style&index=0&id=673bbf73&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673bbf73"]])

export default __exports__